import { Box, Button, styled, Typography } from '@mui/material';

import { Select } from '@widget/toolbox/components';
import { neutrals } from '@widget/toolbox/style/theme/common/ThemeProvider/colors';

export const Wrap = styled(Box)`
  flex-direction: column;
  margin: 24px 0;
  padding: 24px 24px 8px 24px;
  padding-bottom: 8px;
  border-radius: 4px;
  border: 0.5px solid ${neutrals.lighter};
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.15);
  background: ${neutrals.contrastText};

  ${(props) => props.theme.breakpoints.down('md')} {
    padding-bottom: 24px;
  }
`;

export const Title = styled(Typography)`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 28px;
`;

export const FormWrap = styled('div')`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  gap: 16px;

  ${(props) => props.theme.breakpoints.down('md')} {
    flex-direction: column;
    gap: 0px;
  }
`;

export const StyledSelect = styled(Select)`
  background: white;
  border-radius: 2px;
`;

export const StyledButton = styled(Button)`
  margin-top: 4px;
  width: 400px;
  min-width: 140px;

  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
  }
`;
